function Star() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="29"
      viewBox="0 0 31 29"
    >
      <path
        d="M13.9173 0.99469L10.2708 8.38813L2.11236 9.57755C0.649312 9.78975
      0.0629744 11.5934 1.12397 12.6265L7.02643 18.3782L5.63039 26.5032C5.3791 27.9718
      6.92592 29.0719 8.22144 28.385L15.5199 24.5487L22.8185 28.385C24.114 29.0663 25.6608
      27.9718 25.4095 26.5032L24.0135 18.3782L29.9159 12.6265C30.9769 11.5934 30.3906
      9.78975 28.9275 9.57755L20.7691 8.38813L17.1226 0.99469C16.4693 -0.323174
      14.5762 -0.339926 13.9173 0.99469V0.99469Z"
        fill="#F9BA18"
      />
    </svg>
  );
}

export default Star;
